const DEFAULT_REQUEST_TIMEOUT = 10;
const DEFAULT_CONNECTION_TIMEOUT = 10;

export const API_URL = process.env.REACT_APP_API_URL as string;
export const API_AGMS_URL = process.env.REACT_APP_AGMS_BASE_URL as string;
export const WEB_SOCKET_URL = process.env.REACT_APP_WEB_SOCKET_URL as string;
export const AGMS_SERVER = process.env.REACT_APP_AGMS_SERVER as string;
export const AGMS_BASE_URL = process.env.REACT_APP_AGMS_BASE_URL as string;
export const SCREENSHOTS_URL = process.env.REACT_APP_SCREENSHOTS_URL as string;

export const REQUST_TIMEOUT =
  parseInt(process.env.REACT_APP_API_TIMEOUT || `${DEFAULT_REQUEST_TIMEOUT}`) *
  1000;

export const CONNECTION_TIMEOUT =
  parseInt(
    process.env.REACT_APP_CONNECTION_TIMEOUT || `${DEFAULT_CONNECTION_TIMEOUT}`
  ) * 1000;

export const USE_LOGGER = Boolean(process.env.USE_LOGGER || "false");
